import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";

import {
  collection,
  onSnapshot,
  doc,
  deleteDoc
} from "firebase/firestore";


const BlockList = () => {


  const navigate = useNavigate();


  const [blockedUsers,setBlockedUsers] = useState([]);

  const [currentUid,setCurrentUid] = useState(null);





  useEffect(()=>{


    const uid =
    localStorage.getItem("nexora_user_uid")
    ||
    auth.currentUser?.uid;



    if(!uid){

      navigate("/login");

      return;

    }



    setCurrentUid(uid);




    const unsubscribe = onSnapshot(

      collection(
        db,
        "block_list",
        uid,
        "blocked_users"
      ),

      (snapshot)=>{


        const users =
        snapshot.docs.map(item=>({

          id:item.id,

          ...item.data()

        }));


        setBlockedUsers(users);



      }


    );





    return ()=>unsubscribe();



  },[navigate]);









  const handleUnblock = async(uid)=>{


    try{


      await deleteDoc(

        doc(

          db,

          "block_list",

          currentUid,

          "blocked_users",

          uid

        )

      );



    }catch(error){


      console.log(error);


    }


  };









  return (


<div style={styles.container}>


<style>{`

*{

box-sizing:border-box;

font-family:-apple-system,
BlinkMacSystemFont,
"Segoe UI",
Roboto,
sans-serif;

}


.block-card{

width:100%;
max-width:480px;
height:100vh;
background:#fafafa;
animation:slide .25s ease;

}


@keyframes slide{

from{

transform:translateX(100%);

}

to{

transform:translateX(0);

}

}



.user-card{

display:flex;
align-items:center;
justify-content:space-between;
background:white;
padding:14px;
border-radius:20px;
margin:10px 16px;
border:1px solid #f1f5f9;

}


.unblock-btn{

background:#fff;
border:1px solid #fecaca;
color:#ef4444;
padding:8px 14px;
border-radius:12px;
font-weight:700;
font-size:12px;

}


`}</style>





<div className="block-card">





{/* HEADER */}

<div style={styles.header}>


<button
className="theme-invariant-white"

onClick={()=>navigate(-1)}

style={styles.backBtn}

>

<svg 
width="24"
height="24"
viewBox="0 0 24 24"
fill="none"
stroke="#0f172a"
strokeWidth="2.5"
>

<path d="M19 12H5M12 19l-7-7 7-7"/>

</svg>


</button>



<h2 className="theme-invariant-white" style={styles.title}>
Block List
</h2>


<div style={{width:24}} />


</div>










{

blockedUsers.length === 0 ?



<div style={styles.empty}>

<div style={{fontSize:"40px"}}>
🚫
</div>


<div style={{
fontWeight:"800",
color:"#334155",
marginTop:"10px"
}}>

No Blocked Users

</div>


<div style={{
fontSize:"13px",
color:"#94a3b8",
marginTop:"5px"
}}>

You have not blocked anyone yet

</div>


</div>



:

blockedUsers.map(user=>(



<div

className="user-card"

key={user.id}

>



<div style={styles.userInfo}>


<img

src={

user.photoURL
||
"https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=100"

}

style={styles.avatar}

/>



<div>


<div style={styles.name}>

{
user.name
||
"Unknown User"
}

</div>


<div style={styles.phone}>

{
user.phoneNumber
||
"No number"
}

</div>


</div>



</div>







<button

className="unblock-btn"

onClick={()=>handleUnblock(user.id)}

>

Unblock

</button>



</div>



))


}







</div>


</div>


  );

};









const styles={



container:{

minHeight:"100vh",

background:"#fafafa",

display:"flex",

justifyContent:"center"

},



header:{

height:"65px",

background:"#fff",

display:"flex",

alignItems:"center",

justifyContent:"space-between",

padding:"0 16px",

borderBottom:"1px solid #f1f5f9"

},



backBtn:{

background:"none",

border:"none",

cursor:"pointer",

padding:0

},



title:{

fontSize:"18px",

fontWeight:"800",

margin:0,

color:"#0f172a"

},



empty:{

height:"80vh",

display:"flex",

flexDirection:"column",

alignItems:"center",

justifyContent:"center"

},



userInfo:{

display:"flex",

alignItems:"center",

gap:"12px"

},



avatar:{

width:"50px",

height:"50px",

borderRadius:"50%",

objectFit:"cover"

},



name:{

fontSize:"15px",

fontWeight:"800",

color:"#0f172a"

},



phone:{

fontSize:"12px",

color:"#64748b",

marginTop:"3px"

}



};




export default BlockList;